import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/analytics";
import "firebase/compat/firestore";
import { firebaseConfig } from "./firebase-config";
import { unMachine } from "./filters";
import VueAnnouncer from "vue-announcer";
import { mapMutations } from "vuex";
import { trackSessionStart, trackSessionEnd } from "./utils/analytics";

Vue.config.productionTip = false;

// Filters.
Vue.filter("unMachine", unMachine);

// Vue announcer.
Vue.use(VueAnnouncer, {}, router);

// Main vue instance.
new Vue({
  router,
  store,

  methods: {
    ...mapMutations(["setDB", "setAnalytics", "setUID", "modifyLoggedIn"]),
  },

  created() {
    firebase.initializeApp(firebaseConfig);

    // Initialize analytics with graceful fallback (ad blockers may block this)
    try {
      const analytics = firebase.analytics();
      this.setAnalytics(analytics);
    } catch (error) {
      console.warn("[Main] Analytics initialization failed (likely blocked by ad blocker):", error.message);
      this.setAnalytics(null);
    }

    firebase.auth().onAuthStateChanged((user) => {
      if (!user) {
        this.modifyLoggedIn(false);
        this.$router.push("/auth").catch(() => {});
      } else {
        // User is authenticated, set UID in store
        this.setUID(user.uid);
        this.modifyLoggedIn(true);

        // Track session start on app load (for returning users)
        // Note: Auth.vue also tracks this on fresh login
        if (this.$router.currentRoute.path !== "/auth") {
          trackSessionStart(user.uid);
        }
      }
    });

    // Set database object.
    const db = firebase.firestore();
    this.setDB(db);

    // Enable offline persistence.
    db.enablePersistence().catch(() => {});

    // Track session end on page unload
    window.addEventListener("beforeunload", () => {
      const uid = this.$store.getters.getUID;
      if (uid) {
        trackSessionEnd(uid);
      }
    });
  },

  render: (h) => h(App),
}).$mount("#app");
